module.exports = __webpack_public_path__ + "img/login.38483a21.svg";